<template>
    <div class="carousel_wrap hidden-xs-only none_992">
        <el-carousel :height="carouselHeight" loop arrow="never">
            <el-carousel-item v-for="(item, index) in imgList" :key="index">
                <img :src="item.src" alt="" class="img_item" />
                <div class="ho_to"></div>
                <div class="ti_font">
                    <div class="logo-line1-row">
                        <!-- <img src="@/assets/home/chnsoft.png" alt="chnsoft" class="chnsoftImg" /> -->
                        <h1 class="line1-text"><span class="highlight-text">华软股份 <span
                                    style="opacity: 0.1;">| </span></span><span>{{ item.line1 }}</span>
                        </h1>
                    </div>
                    <div class="logo-line1-row">
                        <h1 class="line1-text"><span style="opacity: 0;">华软股份 <span
                                    style="opacity: 0.1;">| </span> </span><span class="line2-text">{{
                                        item.line2 }}</span></h1>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>

    </div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [
                {
                    src: require(`@/assets/home/aboutTop.png`),
                    line1: '引领智能化变革', // 动态设置 line1
                    line2: '具身智能及无人异构集群技术在工业场景应用的先行者',

                }
            ],
            currentSource: '', // 用于存储当前的 source 参数
            carouselHeight: '680px', // 新增
        };
    },
    created() {
        // this.updateImgList();
        this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
    },
    mounted() {
        this.setCarouselHeight();
        window.addEventListener('resize', this.setCarouselHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setCarouselHeight);
    },
    methods: {
        setCarouselHeight() {
            const width = window.innerWidth;
            if (width <= 1370) {
                this.carouselHeight = '520px';
            } else if (width <= 1680) {
                this.carouselHeight = '512px';
            } else {
                this.carouselHeight = '680px';
            }
        },
        //   updateImgList() {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     const source = urlParams.get('source');
        //     const selectedText = localStorage.getItem('selectedText') || '默认文本'; // 获取 localStorage 中的 selectedText
        //     if (source) {

        //       this.imgList = [
        //         {
        //           src: require(`@/assets/home/aboutTop.png`),
        //           line1: selectedText, // 动态设置 line1
        //           line2: '是面向立体空间的全维度无人化智能巡视解决方案，核心实现空、地、海无人装备作业的一体化管控，突破多场景壁垒，织就贯通空、地、海立体巡视网，依托于异构协同、人工智能、边缘计算等新兴技术，实现从装备调度到数据研判的全链条自动化，为各领域筑牢高效精准的全域态势感知屏障。',
        //         },
        //         // 可以根据需要添加更多图片
        //       ];
        //     } else {
        //       this.imgList = []; // 清空 imgList 以防止显示旧数据
        //     }
        //   },
    },
};
</script>

<style lang="scss" scoped>
.ho_to {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    // background: linear-gradient(180deg, rgba(28, 54, 93, 0.9) 0%, rgba(28, 54, 93, 0.3) 100%, rgba(28, 54, 93, 0) 100%);
}

.carousel_wrap {
    position: relative;

    .el-carousel__item {
        img {
            width: 100%;
            // height: 100%;
            object-fit: cover;
        }
    }

    .ti_font {
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 5;
        font-family: PingFang SC;
        line-height: 60px;
        letter-spacing: normal;
        color: #1E242A;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        padding-left: 30%;

        /* Removed the previous font-size declaration */
        .chnsoftImg {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;
            margin: 0px;
        }

        .logo-line1-row {
            display: flex;
            align-items: center;

            /* 保证图片和文字垂直居中 */
            h1.line1-text {
                margin-left: 12px;
                font-size: 25PX;
                font-weight: bold;
                line-height: 1;

                font-family: PingFang SC;
                font-size: 42PX;
                font-weight: bold;
                line-height: 60px;
                letter-spacing: normal;
                /* 1E242A */
                color: #1E242A;
            }
        }

        .line2-text {
            font-family: PingFang TC;
            font-size: 20PX;
            line-height: normal;
            // letter-spacing: normal;
            color: #1E242A;
            white-space: nowrap;
            width: 808px;
            // margin-left: 26.5%;
            margin-top: 3%;
            font-weight: normal !important;
            // font-variation-settings: "opsz" auto;
        }

        // 可选：如果你在模板中细分了span，可以加如下样式
        // .line2-text .strong {
        //     font-weight: bold;
        // }
        // .line2-text .normal {
        //     
        // }

        @media screen and (max-width: 992px) {
            font-size: 0.5rem;
        }

    }
}

::v-deep .el-carousel__button {
  display: none;
}
</style>